import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Layout from './components/Layout';
import IndexPage from './pages/Index';
import ContactPage from './pages/Contact';
import Service from './pages/Services';
import ScrollToTop from './components/ScrollToTop'; // <-- Add this line
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import TeamPage from './pages/Team';

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop /> {/* <-- This ensures scroll resets on route change */}
      <Routes>
        <Route path="/" element={
          <Layout>
            <IndexPage />
          </Layout>
        } />
        <Route path="/contact" element={
          <Layout>
            <ContactPage />
          </Layout>
        } />
        <Route path="/services" element={
          <Layout>
            <Service />
          </Layout>
        } />
        <Route path="/team" element={
          <Layout>
            <TeamPage />
          </Layout>
        } />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
